import { AppError } from "@/store/types";
import { AlertTriangle, WifiOff } from "lucide-react";
import { toast } from "sonner";
import { useEffect } from "react";

interface ErrorPanelProps {
  error: AppError;
}

export function ErrorAlert({ error }: ErrorPanelProps) {
  useEffect(() => {
    const getErrorIcon = () => {
      switch (error.type) {
        case "network":
          return <WifiOff className="h-4 w-4" />;
        default:
          return <AlertTriangle className="h-4 w-4" />;
      }
    };

    const getErrorTitle = () => {
      switch (error.type) {
        case "network":
          return "Network Connection Error";
        default:
          return "Application Error";
      }
    };

    const getErrorMessage = () => {
      switch (error.type) {
        case "network":
          return "Unable to connect to our servers. Please check your internet connection and try again.";
        default:
          return "An unexpected error occurred. Please try again later or contact support if the problem persists.";
      }
    };

    const showErrorToast = () => {
      const title = getErrorTitle();
      const message = getErrorMessage();
      const icon = getErrorIcon();

      // Show the toast with the appropriate styling and actions
      toast.error(title, {
        description: message,
        icon: icon,
        duration: 5000, // Keep error toasts visible longer
      });
    };

    showErrorToast();
  }, [error]);

  // Return null since we're using toasts instead of rendering UI
  return null;
}
